import React from 'react';
import { Linkedin, Instagram, Send } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050816] py-12 border-t border-white/10" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-184">
        <div className="text-gray-400 text-sm" data-id="element-185">
          © ARMAR Solutions 2026. Всі права захищено.
        </div>

        <div className="flex gap-6" data-id="element-186">
          <a href="https://t.me/armarsolutions" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-187">
            <Send className="w-5 h-5" data-id="element-188" />
          </a>
          <a href="https://www.instagram.com/armar.solutions/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors" data-id="element-189">
            <Instagram className="w-5 h-5" data-id="element-190" />
          </a>
          <a href="https://www.linkedin.com/company/86461657/admin/dashboard/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors" data-id="element-191">
            <Linkedin className="w-5 h-5" data-id="element-192" />
          </a>
        </div>
      </div>
    </footer>;
}